import React from 'react';
import { Box, useTheme } from '@mui/material';
import { SimpleProjectionYearResult } from '../../../../../types/SimpleProjection';
import ProjectedRevenueChart from './ProjectedRevenueChart';
import ProjectedNetIncomeChart from './ProjectedNetIncomeChart';
import ProjectedEPSChart from './ProjectedEPSChart';
import ProjectedSharePriceChart from './ProjectedSharePriceChart';

interface ProjectionChartsGridProps {
  projections: SimpleProjectionYearResult[];
  ticker: string;
  transparentBg?: boolean;
}

const chartCardSx = (isDark: boolean) => ({
  backgroundColor: isDark ? '#212121' : '#f5f5f5',
  border: isDark ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)',
  borderRadius: 2,
  overflow: 'hidden',
});

const ProjectionChartsGrid: React.FC<ProjectionChartsGridProps> = ({ projections, ticker, transparentBg = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
        gap: 2,
      }}
    >
      <Box sx={{ ...chartCardSx(isDark), px: 1.5, pt: 1.5, pb: 0 }}>
        <ProjectedRevenueChart projections={projections} ticker={ticker} transparentBg={true} />
      </Box>
      <Box sx={{ ...chartCardSx(isDark), px: 1.5, pt: 1.5, pb: 0 }}>
        <ProjectedNetIncomeChart projections={projections} ticker={ticker} transparentBg={true} />
      </Box>
      <Box sx={{ ...chartCardSx(isDark), px: 1.5, pt: 1.5, pb: 0 }}>
        <ProjectedEPSChart projections={projections} ticker={ticker} transparentBg={true} />
      </Box>
      <Box sx={{ ...chartCardSx(isDark), px: 1.5, pt: 1.5, pb: 0 }}>
        <ProjectedSharePriceChart projections={projections} ticker={ticker} transparentBg={true} />
      </Box>
    </Box>
  );
};

export default ProjectionChartsGrid;
